import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=4e134633&scoped=true&"
import script from "./Moderation.vue?vue&type=script&lang=js&"
export * from "./Moderation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e134633",
  null
  
)

export default component.exports